<template>
  <div id="sistem-pengawasan">

    <banner
      title="Sistem Pengaduan"
      description="Laporkan masalah terkait buku pelajaran Kemendikbud disini. Setiap laporan sangat berguna untuk meningkatkan kualitas buku Pelajaran Sekolah"
      :breadcrumbs="breadcrumbs"
      :icon="require('@/assets/sistem-pengawasan/decoration/Vector.svg')"
    />

    <!-- Tolong buatkan coming soon -->
    <div class="coming-soon text-center my-5">
      <!-- Fontawesome icon -->
      <h2 class="text-primary font-weight-bold">Dashboard Statistik</h2>
      <p class="lead text-muted m-0">Fitur ini sedang dalam pengembangan dan akan segera hadir...</p>
    </div>

    <!-- <section id="content" class="mt-4 px-3 px-lg-5">
      <h3 class="text-dark mb-3">Dashboard Statistic Pengaduan Buku</h3>
      <h6>Diperbaharui terakhir : <b>Rabu, 01 Mei 2024 Pukul 12:00 WIB</b></h6>
      <div class="row mt-5">
        <div class="col-lg-7">
          <div class="row">
            <div class="col-lg-4">
              <div class="card p-3 shadow-sm rounded border-0 bg-primary-50 hover">
                <div class="d-flex mb-3">
                  <div class="d-flex rounded align-items-center justify-content-center bg-primary-100 p-3">
                    <img src="@/assets/sistem-pengawasan/icon/total-laporan.svg" alt="">
                  </div>
                </div>
                <h5 class="text-muted">Total Laporan</h5>
                <div class="d-flex justify-content-between align-items-center">
                  <h1 class="mb-0">{{ reports.length }}</h1>
                  <div class="rounded-circle bg-white d-flex align-items-center justify-content-center" style="width: 35px; height: 35px;transform: rotate(45deg);"><i class="fa fa-lg fa-arrow-up text-success"></i></div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="card p-3 shadow-sm rounded border-0 bg-secondary-50 hover">
                <div class="d-flex mb-3">
                  <div class="d-flex rounded align-items-center justify-content-center bg-secondary-100 text-secondary p-3">
                    <img src="@/assets/sistem-pengawasan/icon/tindak-lanjut-2.svg" alt="">
                  </div>
                </div>
                <h5 class="text-muted">Tindak Lanjut</h5>
                <div class="d-flex justify-content-between align-items-center">
                  <h1 class="mb-0">{{ reports.filter(report => report.status === 'Terkirim').length }}</h1>
                  <div class="rounded-circle bg-white d-flex align-items-center justify-content-center" style="width: 35px; height: 35px;transform: rotate(45deg);"><i class="fa fa-lg fa-arrow-up text-success"></i></div>
                </div>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="card p-3 shadow-sm rounded border-0 bg-success-50 hover">
                <div class="d-flex mb-3">
                  <div class="d-flex rounded align-items-center justify-content-center bg-success-70 text-secondary p-3">
                    <img src="@/assets/sistem-pengawasan/icon/laporan-selesai.svg" alt="">
                  </div>
                </div>
                <h5 class="text-muted">Laporan Selesai</h5>
                <div class="d-flex justify-content-between align-items-center">
                  <h1 class="mb-0">{{ reports.filter(report => report.status === 'Selesai').length }}</h1>
                  <div class="rounded-circle bg-white d-flex align-items-center justify-content-center" style="width: 35px; height: 35px;transform: rotate(45deg);"><i class="fa fa-lg fa-arrow-up text-success"></i></div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <img src="@/assets/sistem-pengawasan/Statistic.png" class="w-100" alt="">
          </div>
        </div>
        <div class="col-lg-5">
          <div class="card p-3 shadow-sm rounded border-0">
            <div class="d-flex align-items-center justify-content-between">
              <h4 class="mb-0">Laporan Tuntas Terbaru</h4>
              <div class="dropdown">
                <button class="btn btn-sm bg-grey-100 dropdown-toggle px-3" type="button" data-toggle="dropdown" aria-expanded="false">
                  Hari ini
                </button>
                <div class="dropdown-menu">
                  <a class="dropdown-item" href="#">Minggu ini</a>
                  <a class="dropdown-item" href="#">Bulan ini</a>
                  <a class="dropdown-item" href="#">Tahun ini</a>
                </div>
              </div>
            </div>
            <div class="mt-4">
              <div v-for="report in reports.filter(report => report.status === 'Selesai').slice(0,7)" :key="report.id" class="d-flex justify-content-between border-bottom py-3">
                <div>
                  <h5 class="mb-3">{{ report.materi }}</h5>
                  <span class="bg-secondary-50 px-2 py-1 rounded-pill">{{ report.kategori }}</span>
                </div>
                <div>{{ convertDate(report.created_at) }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <CTA/>

  </div>
</template>
<style scoped>
.sidebar {
  border: 1px solid #dbddf0;
  border-radius: 0.5rem;
  padding: 1rem;
}
</style>
<script>
// import { mapActions, mapState } from "vuex";
import Banner from "../../components/homepage/Banner.vue";
import CTA from "../../components/sistem-pengawasan/CTA.vue";
import axios from "axios";
import { BASE_URL } from "../../store";
import moment from "moment"

export default {
  components: { Banner, CTA },
  watch: {
    filter() {
      this.pageNumber = 1;
    },
  },
  data() {
    return {
      reports: [],
      breadcrumbs: [
        {
          label: "Beranda",
          url: "/",
        },
        {
          label: "Sistem Pengaduan",
          url: "",
        },
      ],
    };
  },
  methods: {
    convertDate(date) {
      return moment(date).format("LLL");
    }
  },
  created() {
    axios.get(`${BASE_URL}api/pengaduan`).then((response) => {
      if (response.data.status == "failed") {
        this.notFound = true;
      } else {
        this.reports = response.data.data;
      }
    })
  },
};
</script>
